import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import WorkshopImg from "../../assets/event-images/workshop.jpg";

const workshop = {
  image: WorkshopImg,
  description:
    "Vaishnav Rengan V, Senior Project Engineer at Soliton Technologies, will guide a hands-on journey through the Software Development Life Cycle (SDLC), covering server scripting, Figma, and Agile methodologies. ",
  type: "Technical Event",
  eventName: "Work Shop",
  dateTime: "March 1, 02.00PM-03:30PM",
  venue: "IT-444",
  rules:[
    "Solo Participation",
    "Vaishnav Rengan V, Senior Project Engineer at Soliton Technologies, will guide a hands-on journey through the Software Development Life Cycle (SDLC), covering server scripting, Figma, and Agile methodologies.",
    "Register at just 149",
    "Certifices will be provided(Soft Copy)."
  ],
  contact: [
    {
      name: "Dharaneesh K",
      phoneNo: "8610168610",
    },
    {
      name: "Kavin",
      phoneNo: "6381040474",
    },
  ],
};


const Workshop = () => {
  return (
    <SingleEventPage
      eventDetails={workshop}
      noPrize={true}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLSeyv6aHErj-l0HtO8wEXIQSvPe71ajdyHLnRA87ult0CQrgCw/viewform?usp=dialog"}
    />
  );
};

export default Workshop;
